module.exports = __webpack_public_path__ + "img/find_provider.0a5619dd.svg";